/*
 * UNIK purchase rules shared by the product page, the size dialog and the wishlist
 * (F2-01). Pure functions without DOM access, exposed as window.UnikPurchaseRules
 * and as a CommonJS module for tests. Ported from the Shella reference
 * (assets/unik-product-purchase.js: quantityForRule, sizeState).
 */
(function (root) {
  'use strict';

  const SIZE_OPTION_NAMES = ['size', 'størrelse'];

  /**
   * Whether an option name is the size option ("Size"/"Størrelse", trimmed,
   * case-insensitive). Gift cards never have a size option. Mirrors
   * snippets/unik-is-size-option.liquid.
   * @param {string} name
   * @param {{ giftCard?: boolean, type?: string }} [product]
   */
  function isSizeOptionName(name, product = {}) {
    if (product.giftCard || String(product.type || '').trim().toLowerCase() === 'gavekort') return false;
    return SIZE_OPTION_NAMES.includes(String(name || '').trim().toLowerCase());
  }

  /**
   * Quantity to add so the variant's quantity rule is met: the minimum rounded up
   * to the increment. The maximum is enforced in the cart, not here (parity).
   * @param {{ min?: number, increment?: number }} [rule]
   */
  function quantityForRule(rule = {}) {
    const minimum = Math.max(1, Number(rule.min) || 1);
    const increment = Math.max(1, Number(rule.increment) || 1);
    return Math.ceil(minimum / increment) * increment;
  }

  /**
   * Whether a value of option `index` exists and is available together with the
   * other selected options. Unselected options (falsy entries) match anything.
   * @param {{ options: string[], available: boolean }[]} variants
   * @param {(string|null|undefined)[]} selectedOptions - Selected value per option position.
   * @param {number} index - Position of the option being evaluated.
   * @param {string} value - The option value to evaluate.
   * @returns {{ exists: boolean, available: boolean }}
   */
  function sizeState(variants, selectedOptions, index, value) {
    const matches = variants.filter(
      (variant) =>
        variant.options[index] === value &&
        variant.options.every((option, other) => other === index || !selectedOptions[other] || option === selectedOptions[other])
    );
    return { exists: matches.length > 0, available: matches.some((variant) => variant.available) };
  }

  const api = { isSizeOptionName, quantityForRule, sizeState };
  root.UnikPurchaseRules = api;
  if (typeof module === 'object' && module.exports) module.exports = api;
})(typeof window === 'undefined' ? globalThis : window);
